import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import ScheduleSection from '../modules/schedule/schedule';
import FlowDiagram from '../modules/flowry/FlowDiagram';
import UseCaseChat from '../modules/flowry/UseCaseChat';
import TeamSection from '../modules/team/team';
import LogoRoller from '../modules/logos/LogoRoller';
import TrackedComponent from '../components/TrackedComponent';
import '../modules/company/company.css';

const FlowryPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO
        title="Flowry"
        description={t('flowry_summary')}
        canonicalUrl="https://cloudsibyl.com/"
      />
      <main className="App-main flowry-page">
        <div className="hero-block company-hero flowry-hero">
          <div className="hero-content">
            <div className="flowry-hero-copy">
              <p className="hero-eyebrow flow-fade-up">
                <span className="hero-eyebrow-dot" aria-hidden="true" />
                {t('flowry_eyebrow')}
              </p>
              <h1 className="main-title flow-fade-up" style={{ animationDelay: '80ms' }}>
                {t('flowry_headline')}
              </h1>
              <p className="main-description flow-fade-up" style={{ animationDelay: '160ms' }}>
                {t('flowry_summary')}
              </p>
              <div
                id="contact"
                className="hero-cta-row flow-fade-up"
                style={{ animationDelay: '240ms' }}
              >
                <ScheduleSection variant="hero" />
                <p className="hero-support">{t('flowry_support')}</p>
              </div>
            </div>
            <div className="flow-fade-up" style={{ animationDelay: '320ms' }}>
              <FlowDiagram />
            </div>
          </div>
        </div>
        <LogoRoller />
        <UseCaseChat />
        <section className="why-section" aria-labelledby="why-title">
          <p className="why-eyebrow">{t('why_eyebrow')}</p>
          <h2 id="why-title">{t('why_title')}</h2>
          <ul className="why-grid">
            {['1', '2', '3', '4', '5', '6'].map((item) => (
              <li key={item}>
                <svg viewBox="0 0 16 16" aria-hidden="true">
                  <path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                <div>
                  <h3>{t(`why_${item}_title`)}</h3>
                  <p>{t(`why_${item}_body`)}</p>
                </div>
              </li>
            ))}
          </ul>
        </section>
        <TrackedComponent sectionName="Team" trackScroll={true}>
          <TeamSection />
        </TrackedComponent>
      </main>
    </>
  );
};

export default FlowryPage;
